/**
 * Phase 14 — Mockup: Cross-Org-Mission. Polizei sichert Tatort, EMS-Maßnahme
 * "Patientenversorgung" wartet (mit Schloss-Icon und Hint).
 */
export function CrossOrgMockup() {
  return (
    <svg
      viewBox="0 0 800 500"
      className="h-auto w-full rounded-xl"
      role="img"
      aria-label="Cross-Organization-Einsatz mit blockierter EMS-Maßnahme"
    >
      <rect width="800" height="500" fill="#0a0e1a" />

      {/* Panel */}
      <rect x="60" y="40" width="680" height="420" rx="14" fill="#11151f" stroke="#1f2937" />

      {/* Header */}
      <text x="90" y="84" fill="#ffffff" fontSize="22" fontWeight="700">
        Messerangriff · Innenstadt
      </text>
      <text x="90" y="106" fill="#9ca3af" fontSize="12">P3 · Cross-Org · Polizei + Rettungsdienst</text>

      {/* Org-Indikatoren */}
      <rect x="90" y="124" width="84" height="22" rx="11" fill="#1d4ed8" />
      <text x="132" y="139" fill="#ffffff" fontSize="10" fontWeight="700" textAnchor="middle">
        POLIZEI
      </text>
      <rect x="180" y="124" width="120" height="22" rx="11" fill="#f97316" />
      <text x="240" y="139" fill="#ffffff" fontSize="10" fontWeight="700" textAnchor="middle">
        RETTUNGSDIENST
      </text>

      {/* Section heading */}
      <text x="90" y="184" fill="#9ca3af" fontSize="11" fontWeight="600" letterSpacing="1.5">
        REIHENFOLGE DER MASSNAHMEN
      </text>

      {/* Step 1 — Police, in progress */}
      <rect x="90" y="200" width="620" height="64" rx="10" fill="#0b1d3d" stroke="#2563eb" />
      <circle cx="120" cy="232" r="14" fill="#2563eb" />
      <text x="120" y="237" fill="#ffffff" fontSize="14" fontWeight="800" textAnchor="middle">1</text>
      <text x="148" y="226" fill="#ffffff" fontSize="13" fontWeight="700">Tatort sichern</text>
      <text x="148" y="244" fill="#bfdbfe" fontSize="11">Polizei · 2 × FuStW vor Ort · läuft</text>
      <rect x="148" y="252" width="160" height="4" rx="2" fill="#1f2937" />
      <rect x="148" y="252" width="96" height="4" rx="2" fill="#3b82f6" />
      <text x="678" y="237" fill="#3b82f6" fontSize="11" fontWeight="700" textAnchor="end">60 %</text>

      {/* Step 2 — EMS, locked */}
      <rect x="90" y="276" width="620" height="64" rx="10" fill="#1a1208" stroke="#451a03" strokeDasharray="6 4" />
      <circle cx="120" cy="308" r="14" fill="#451a03" stroke="#9a3412" strokeWidth="1.5" />
      {/* Lock icon */}
      <rect x="114" y="304" width="12" height="9" rx="1.5" fill="#fbbf24" />
      <path
        d="M 117 304 V 300 a 3 3 0 0 1 6 0 V 304"
        fill="none"
        stroke="#fbbf24"
        strokeWidth="1.5"
      />
      <text x="148" y="302" fill="#fde68a" fontSize="13" fontWeight="700">Patientenversorgung</text>
      <text x="148" y="320" fill="#a16207" fontSize="11">Rettungsdienst · wartet auf: „Tatort sichern"</text>
      <text x="678" y="313" fill="#fbbf24" fontSize="11" fontWeight="700" textAnchor="end">
        gesperrt
      </text>

      {/* Step 3 — EMS transport, queued */}
      <rect x="90" y="352" width="620" height="64" rx="10" fill="#0b1426" stroke="#1f2937" />
      <circle cx="120" cy="384" r="14" fill="#1f2937" />
      <text x="120" y="389" fill="#9ca3af" fontSize="14" fontWeight="800" textAnchor="middle">3</text>
      <text x="148" y="378" fill="#9ca3af" fontSize="13" fontWeight="700">Transport in Klinik</text>
      <text x="148" y="396" fill="#6b7280" fontSize="11">RTW · wartet auf Patientenversorgung</text>
    </svg>
  );
}
